import { useEffect, useMemo, useState } from "react";

interface UseTrustedFormOptions {
  formId: string;
  sandbox?: boolean;
}

interface TrustedFormParams {
  [key: string]: string;
  field: string;
  formSelector: string;
  sandbox: string;
  l: string;
}


export function useTrustedForm({ formId, sandbox = true }: UseTrustedFormOptions): string {
  const [certUrl, setCertUrl] = useState<string>("");

  const trustedFormParams = useMemo<TrustedFormParams>(() => ({
    field: "xxTrustedFormCertUrl",
    formSelector: `#${formId}`,
    sandbox: String(sandbox),
    l: `${Date.now()}${Math.random()}`,
  }), [formId, sandbox]);

  window.trustedFormCertUrlCallback = setCertUrl;

  useEffect(() => {
    const url = new URL(`${window.location.protocol === "https:" ? "https" : "http"}://api.trustedform.com/trustedform.js`);
    const params = new URLSearchParams(trustedFormParams);
    url.search = params.toString();

    const script = Object.assign(document.createElement("script"), {
      src: url.toString(),
      async: true,
    });

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [trustedFormParams]);

  return certUrl;
}
